import React, { useEffect, useState} from 'react'
import styles from './DocumentsPage.module.css'
import {
    Button,
} from '@material-ui/core'

import axios from "axios";
import LoadingBackdrop from "../../../components/common/LoadingBackdrop";
import Snackbar from "@mui/material/Snackbar";
import {Alert, FormControl, Grid} from "@mui/material";
import Box from "@mui/material/Box";
import HookForm from "../../../components/common/HookForm";
import {useForm} from "react-hook-form";
import AutocompleteSelect from "../../../components/common/inputs/AutoCompleteSelectInput";
import Typography from "@mui/material/Typography";
import DocumentsFileViewerPage from "../../FileViewerPage/Documents/DocumentsFileViewerPage";

interface FormData {
    phone: string,
    divisionid: number
    woid: number
    pmid: number
    addressid: number
}

const DocumentsPage = (params) => {
    const formMethods = useForm<FormData>()
    const { setValue, watch, resetField } = formMethods
    const [snackbarOpen, setSnackbarOpen] = React.useState({ open: false, message: '' })
    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const [customerNumber, setCustomerNumber] = useState("");
    const [woList, setWoList] = React.useState([])
    const [divisionList, setDivisionList] = React.useState([])
    const [pmNumberList, setPMNumbertList] = React.useState([])
    const watchDivision = watch('divisionid', null)
    const watchwoid = watch('woid', null)
    const watchaddressid = watch('addressid', null)
    const watchpmid = watch('pmid')
    const [back, setBack] = React.useState('main')
    const [reloadTab, setReloadTab] = React.useState<number>(0)
    const [isLoading, setIsLoading] = React.useState<boolean>(false)

    const [errors, setErrors] = useState({
        customernumber: '',
    });
    const [documentData, setDocumentData] = React.useState(
        {
            woid: 0,
            addresslist: [],
            employee: '',
            pmnumberlist: [],
            selecteddivisionid: 0,
            workorderlist: [],
            divisionlist: [],
            wocustomerrelease: "",
            wocustomerworkcode: "",
            wocustomerworkorder: "",
            wostatus: "",
            woaddress: "",
        })

    useEffect(() => {
        setLoadingBackdrop(true)
        params.setTitle('Documents')
    }, [])

    useEffect(() => {
        var woidTemp = null
        if (watchwoid) {
            woidTemp = watchwoid
        }
        else if (watchpmid) {
            woidTemp = watchpmid
        }
        else if (watchaddressid) {
            woidTemp = watchaddressid
        }

        getDocumentData(watchDivision ? watchDivision : null, woidTemp)
    }, [watchwoid, watchpmid, watchaddressid])

    useEffect(() => {
        if (params.displayFileViewer) {
            params.setDisplayFileViewer(false)
            params.setBackArrow('main')
        }
    }, [params.backArrowClick])

    const getDocumentData = (divisionid, woid) => {
        var body = {}
        if  (divisionid) {
            body['divisionid'] = divisionid
        }
        if  (woid) {
            body['woid'] = woid
        }
        axios.post(`fieldsystemdocument`, body).then((response) => {
            const parsedResponse = JSON.parse(response?.data.jsonString)

            if (parsedResponse?.divisionlist?.length > 0) {
                setDivisionList(parsedResponse?.divisionlist.map(item => { return {label: item.division, value: item.divisionid}}))
            }
            if (parsedResponse?.pmnumberlist?.length > 0) {
                setPMNumbertList(parsedResponse?.pmnumberlist.map(item => {
                    return {label: item.info, value: item.woid}
                }))
            }
            if (parsedResponse?.workorderlist?.length > 0) {
                setWoList(parsedResponse?.workorderlist.map(item => {
                    return {label: item.info, value: item.woid}
                }))
            }

            debugger
            setDocumentData({...documentData, ...parsedResponse})
            if (parsedResponse?.selecteddivisionid >= 0) {
                resetField('divisionid', { keepDirty: true, keepError: true, keepTouched: true, defaultValue: parsedResponse?.selecteddivisionid })
            }

            setLoadingBackdrop(false)
        })
    }
    const onSubmit = async () => {
        if (validate()) {
            setLoadingBackdrop(true)
            const body = {
                customernumber: customerNumber,
            }

            axios.post(`fieldsystememergency`, body).then((response) => {
                const parsedResponse = JSON.parse(response?.data.jsonString)
                setLoadingBackdrop(false)
                setSnackbarOpen( { open: true, message: 'Created Work Order - ' + parsedResponse.woid})
            })
        }
    }

    const validate = () => {
        let isValid = true;
        let newErrors = {
            customernumber: "",
        }

        if (!customerNumber) {
            newErrors.customernumber = "Please a customer number.";
            isValid = false;
        }

        setErrors(newErrors)
        return isValid
    }


    const handleSnackbarClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen({ open: false, message: ""  });
    }

    const getAddressOptions = () => {
        return documentData?.addresslist?.map(item => {
             return {value: item.woid, label: item.info}
         })
        return []
    }

    const getPMOptions = () => {
        return documentData?.pmnumberlist?.map(item => {
            return {value: item.woid, label: item.info}
        })
        return []
    }

    const getDivisionOptions = () => {
        return documentData?.divisionlist?.map(item => {
            return {value: item.divisionid, label: item.division}
        })
        return []
    }

    const getWOOptions = () => {
        return documentData?.workorderlist?.map(item => {
            return {value: item.woid, label: item.info}
        })
        return []
    }




    return (
        <div className={styles.root}>
            {params.displayFileViewer &&
                <DocumentsFileViewerPage woid={documentData.woid} reloadTab={reloadTab} setIsLoading={setIsLoading} isLoading={isLoading} />
            }
            <LoadingBackdrop open={loadingBackdrop} />
            <>
                <Snackbar
                    open={snackbarOpen.open}
                    autoHideDuration={4000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                >
                    <Alert severity="success">
                        {snackbarOpen.message}
                    </Alert>
                </Snackbar>
            </>
            <div hidden={params.displayFileViewer}>
                <HookForm
                    methods={formMethods}
                    onSubmit={onSubmit}
                    className={styles.form}>

                    <FormControl fullWidth>
                        {/*<FormLabel style={{marginBottom: '10px'}} component="legend">Select a division to continue</FormLabel>*/}
                        <AutocompleteSelect
                            name="divisionid"
                            label="Division"
                            options={getDivisionOptions()}
                            required={true}
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <AutocompleteSelect
                            name="woid"
                            label="Work Order"
                            options={getWOOptions()}
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <AutocompleteSelect
                            name="pmid"
                            label="PM Number / Release"
                            options={getPMOptions()}
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <AutocompleteSelect
                            name="addressid"
                            label="Address"
                            options={getAddressOptions()}
                        />
                    </FormControl>
                    <FormControl fullWidth>
                    <Box hidden={!watchwoid && !watchpmid && !watchaddressid}>
                        <Grid
                            container
                            border={.5}
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                            // height={'100%'}
                            // width={'100%'}
                        >
                            <>
                                <Grid item border={.25} xl={12} md={12} xs={12}>
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        width={'100%'}
                                    >
                                        <Typography variant="h5" gutterBottom>
                                            {'Selected WO # ' + documentData.woid}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item border={0} xl={6} md={6} xs={12}>
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        width={'100%'}
                                    >
                                        <Typography variant="subtitle1">
                                            {'PM # ' + documentData.wocustomerworkorder}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item border={0} xl={6} md={6} xs={12}>
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                    >
                                        <Typography variant="subtitle1">
                                            {'Release ' + documentData.wocustomerrelease}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item border={0} xl={6} md={6} xs={12}>
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                    >
                                        <Typography variant="subtitle1">
                                            {'Address ' + documentData.woaddress}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item border={0} xl={6} md={6} xs={12}>
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                    >
                                        <Typography variant="subtitle1">
                                            {'Material Code: ' + documentData.wocustomerworkcode}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item border={0} xl={6} md={6} xs={12}>
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                    >
                                        <Typography variant="subtitle1">
                                            {'Status: ' + documentData.wostatus}
                                        </Typography>
                                    </Box>
                                </Grid>
                            </>
                        </Grid>
                    </Box>
                    </FormControl>
                    <Button disabled={watchwoid == null && watchpmid == null && watchaddressid == null} onClick={()=> {params.setDisplayFileViewer(true)}} type="submit" variant="contained" style={{width: '100%'}}>
                        Go To Work Order
                    </Button>
                </HookForm>
            </div>
        </div>
    )
}

export default DocumentsPage